import React from "react";


export default function CustomHorizontalSpace ({space}){
    return <div style={{height: space}}/>
}



